import React, { useEffect, useRef, useState } from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import { withRouter, useParams } from "react-router-dom";
import _ from "lodash";

// @material-ui/icons
import Hidden from "@material-ui/core/Hidden";
import { makeStyles } from "@material-ui/core/styles";
import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";
import FormHelperText from "@material-ui/core/FormHelperText";

import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import GridContainer from "components/Grid/GridContainer.js";
import CardBody from "components/Card/CardBody.js";
import GridItem from "components/Grid/GridItem.js";
import Accordion from "components/Accordion/Accordion";
import Button from "components/CustomButtons/Button.js";

import MobileWrapper from "componentsCustom/Mobile/MobileWrapper.js";
import VisitorInformation from "componentsCustom/Information/VisitorInformation";

import shippingAddressStyle from "assets/jss/material-dashboard-pro-react/views/shippingAddressStyle.js";
import styles from "./InformationList.module.css";

import SidebarCart from "../container/view/SidebarCartContainer";

// import articoli from "api/articoli.json";

const useStyles = makeStyles(shippingAddressStyle);

function sortCart(a, b) {
  // Use toUpperCase() to ignore character casing
  const idA = a.index;
  const idB = b.index;

  let comparison = 0;
  if (idA > idB) {
    comparison = 1;
  } else if (idA < idB) {
    comparison = -1;
  }
  return comparison;
}

function BaseInformationList(props) {
  const {
    cart,
    customStyle,
    shippingInfo,
    history,
    //
    cartUnique,
    updateCartUnique,
  } = props;

  const { t } = useTranslation();
  const classes = useStyles();
  const formRef = useRef(null);

  const { home } = useParams();

  const [cardErrorArray, setCardErrorArray] = useState([]);
  const [anyCardRepetition, setAnyCardRepetition] = useState(false);

  const [showError, setShowError] = useState(false);

  useEffect(() => {
    cart.sort(sortCart);

    if (!cartUnique || (cartUnique && Object.keys(cartUnique).length === 0)) {
      const cartSplitted = [].concat(
        ...cart.map((el, index) => {
          const arr = [];
          for (let i = 0; i < el.quantity; i += 1) {
            // CREO UN TICKET ID DIVERSO PER OGNI BIGLIETTO - DOVREBBE ESSERE UNIVOCO
            // CREO UN OGGETTO PER OGNI VISITATORE
            const ticketId = `${new Date().getTime().toString() + i}${index}`;
            if (i === 0) {
              arr[i] = Object.assign({}, el, {
                ticketId,
                visitatore: {
                  tessera: "",
                  nome: shippingInfo.firstName, // required ???
                  cognome: shippingInfo.lastName, // required ???
                  codice_biglietto: ticketId,
                  flag_data_aperta: false,
                  email: shippingInfo.email,
                },
              });
            } else {
              arr[i] = Object.assign({}, el, {
                ticketId,
                visitatore: {
                  tessera: "",
                  nome: "", // required ???
                  cognome: "", // required ???
                  codice_biglietto: ticketId,
                  flag_data_aperta: false,
                  email: shippingInfo.email,
                },
              });
            }
          }
          return arr;
        })
      );

      let groupCart = _.groupBy(cartSplitted, (el) => {
        return el.productId;
      });

      const groupCartArray = _.reduce(
        groupCart,
        (acc, data, key) => {
          let categoryObj = {
            productId: key,
          };
          if (data && data[0] && data[0].item) {
            categoryObj = Object.assign({}, categoryObj, {
              nome_articolo: data[0].item.nome_articolo,
            });
          }
          acc.push({
            ...categoryObj,
            data,
          });
          return acc;
        },
        []
      );

      updateCartUnique(groupCartArray);

      // OGGETTO DI TEST
      // updateCartUnique(cartUniqueJson);
    } else {
      // DEVO CONTROLLARE SE LE QUANTITÀ DEI BIGLIETTI SONO RIMASTE LE STESSE
      // CREO UN ARRAY CON TUTTE LE QUANTITÀ PER OGNI CATEGORIA
      const cartQuantity = cart.map((el) => {
        return {
          categoria_articolo: el.categoria_articolo,
          productId: el.productId,
          quantity: el.quantity,
        };
      });
      // ESEGUO UN CONTROLLO PER OGNI CATEGORIA
      const checkCart = cartQuantity.every((current) => {
        if (cartUnique) {
          const findProduct = cartUnique.find((el) => {
            return el?.productId?.toString() === current?.productId?.toString();
          });
          if (findProduct) {
            if (
              findProduct.data &&
              findProduct.data.length === current.quantity
            ) {
              return true;
            }
            return false;
          }
          return false;
        }
        return false;
      });

      // SE CHECKCART È TRUE SIGNIFICA CHE IL CARRELLO E I DATI UTENTE SONO COMPATIBILI
      // SE È FALSE DEVO AGGIORNARE I DATI UTENTE
      if (!checkCart) {
        // RICOSTRUISCO IL CARTUNIQUE
        const cartSplitted = [].concat(
          ...cart.map((el, index) => {
            const arr = [];
            for (let i = 0; i < el.quantity; i += 1) {
              // CREO UN TICKET ID DIVERSO PER OGNI BIGLIETTO - DOVREBBE ESSERE UNIVOCO
              // CREO UN OGGETTO PER OGNI VISITATORE

              // CONTROLLO SE ESISTE UN VALORE SU CARTUNIQUE
              const findCartUniqueTicket = cartUnique.find(
                (item) =>
                  item?.productId?.toString() === el.productId?.toString()
              );

              if (findCartUniqueTicket?.data && findCartUniqueTicket?.data[i]) {
                arr[i] = findCartUniqueTicket?.data[i];
              } else {
                const ticketId = `${new Date().getTime().toString() +
                  i}${index}`;
                arr[i] = Object.assign({}, el, {
                  ticketId,
                  quantity: 1,
                  visitatore: {
                    CAP: "",
                    nazione: "",
                    sesso: "",
                    nascita: null, // required
                    tessera: "",
                    nome: "", // required ???
                    cognome: "", // required ???
                    codice_biglietto: ticketId,
                    flag_data_aperta: false,
                    email: shippingInfo.email,
                  },
                });
              }
            }
            return arr;
          })
        );

        let groupCart = _.groupBy(cartSplitted, (el) => {
          return el.productId;
        });

        const groupCartArray = _.reduce(
          groupCart,
          (acc, data, key) => {
            let categoryObj = {
              productId: key,
            };
            if (data && data[0] && data[0].item) {
              categoryObj = Object.assign({}, categoryObj, {
                nome_articolo: data[0].item.nome_articolo,
              });
            }
            acc.push({
              ...categoryObj,
              data,
            });
            return acc;
          },
          []
        );

        updateCartUnique(groupCartArray);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cart]);

  useEffect(() => {
    // check if any card has been provided form more than one user
    let repetitionFound = false;
    cardErrorArray.forEach((element) => {
      if (element !== undefined) {
        element.forEach((item) => {
          if (item !== undefined && alreadyProvided(item[1])) {
            repetitionFound = true;
          }
        });
      }
    });
    if (repetitionFound) {
      setAnyCardRepetition(true);
    } else {
      setAnyCardRepetition(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cardErrorArray]);

  function updateVisitorInformation(productId, index, key, value) {
    const copyCartUnique = JSON.parse(JSON.stringify(cartUnique));

    const findIndexCatToChange = cartUnique.findIndex(
      (el) => el.productId === productId
    );
    if (findIndexCatToChange !== -1) {
      const findElementToChange =
        cartUnique[findIndexCatToChange]?.data[index]?.visitatore;

      if (findElementToChange) {
        findElementToChange[key] = value;
        copyCartUnique[findIndexCatToChange].data[
          index
        ].visitatore = findElementToChange;
        updateCartUnique(copyCartUnique);
      }
    }
  }

  function setCardErrorArrayCell(col, row, boolValue, cardNumber) {
    let arr = [...cardErrorArray];
    if (arr[col] === undefined) {
      arr[col] = new Array([]);
    }
    arr[col][row] = [boolValue, cardNumber];
    setCardErrorArray(arr);
  }

  const alreadyProvided = (cellValue) => {
    let res = false;
    let foundOne = false;
    cardErrorArray.forEach((row) => {
      if (row !== undefined) {
        row.forEach((el) => {
          if (el !== undefined && el[1] !== undefined) {
            if (cellValue === el[1]) {
              if (!foundOne) {
                foundOne = true;
              } else {
                res = true;
                return res;
              }
            }
          }
        });
      }
    });
    return res;
  };
  function isEmpty(value) {
    return value === "" || value === null || value === undefined;
  }

  function onClickContinue() {
    // TODO ADD CHECKER AND NAVIGATION
    // PRIMA DI CONTINUARE CONTROLLARE CHE I VALORI SONO VALIDI
    let errorObj = {};
    // FACCIO IL CONTROLLO PER OGNI OGGETTO NELLA LISTA
    cartUnique.forEach((item, index) => {
      item.data.forEach((element, i) => {
        // CONTROLLO NOME E COGNOME
        if (!element?.visitatore?.nome || !element?.visitatore?.cognome) {
          errorObj[`${index}_${i}`] = Object.assign(
            {},
            errorObj[`${index}_${i}`] || {},
            {
              info: true,
            }
          );
        }

        if (
          element.visitatore.additional_info.some(
            (field) => field.mandatory === true && isEmpty(field.value)
          )
        ) {
          errorObj[`${index}_${i}`] = Object.assign(
            {},
            errorObj[`${index}_${i}`] || {},
            {
              info: true,
            }
          );
        }
      });
    });

    // check if every card exists, otherwise cannot go on to payment
    //  and if any card is provided more than once, in which case cannot go on to payment
    cardErrorArray.forEach((element) => {
      if (element !== undefined) {
        element.forEach((item, index) => {
          if (item !== undefined) {
            if (item[0] === true || alreadyProvided(item[1])) {
              //error for that card
              errorObj[`${index}`] = Object.assign(
                {},
                errorObj[`${index}`] || {},
                {
                  info: true,
                }
              );
            }
          }
        });
      }
    });

    if (cartUnique?.length === 0 || cart?.length === 0) {
      // IL CARRELLO è vuoto NON POSSO CONTINUARE
    } else if (errorObj && Object.keys(errorObj).length === 0) {
      // NO ERRORS

      //We cannot simply push the path as we have the home page as last parameter of the URL
      var url = history.location.pathname;
      url = url.slice(0, url.lastIndexOf("/"));
      url = url.slice(0, url.lastIndexOf("/")) + "/payment/" + home;

      history.replace(url);
    } else {
      // TODO AGGIUNGERE ALERT PARAMETRI ERRATI
      formRef.current.scrollIntoView();
      setShowError(true);
    }
  }

  return (
    <>
      <MobileWrapper
        type={"contacts"}
        showButtons
        buttons={[
          {
            onClick: () => {
              onClickContinue();
            },
            color: "lightBlue",
            text: t("shippingAddress.continue"),
            isActive: cartUnique && cartUnique.length > 0,
            customStyle: { backgroundColor: customStyle.buttonAction },
            path: `payment`,
          },
          {
            onClick: () => {},
            color: "whiteRed",
            text: t("shippingAddress.back_menu"),
            isActive: true,
            path: `../shop`,
            classNameText: classes.buttonBigTextMenu,
            customColor: customStyle.buttonAction,
          },
        ]}
      >
        <div className={styles.sidenavContainer}>
          <SidebarCart showGoToCheckout={false} />
        </div>
        <div className={styles.contentContainer}>
          <div ref={formRef} className={classes.container}>
            <Card className={classes.card}>
              <CardBody>
                <Button
                  round
                  size="sm"
                  color="transparent"
                  className={classes.buttonBack}
                  // style={styles.backSweetAlertStyle}
                  onClick={() => {
                    var url = history.location.pathname;
                    url = url.slice(0, url.lastIndexOf("/"));
                    url =
                      url.slice(0, url.lastIndexOf("/")) + "/contacts/" + home;

                    history.replace(url);
                  }}
                >
                  <span
                    className={classes.buttonText}
                    style={{ fontSize: "11px", paddingLeft: "6px" }}
                  >
                    <ArrowBackIosIcon style={{ marginRight: 0 }} />
                  </span>
                </Button>
                <CardHeader>
                  <h1 className={classes.title}>
                    {t("userInformation.title")}
                  </h1>
                </CardHeader>
                <CardBody>
                  {cartUnique && cartUnique.length > 0 ? (
                    <Accordion
                      active={0}
                      customStyle={customStyle}
                      collapses={cartUnique.map((el, prodIndex) => {
                        return {
                          title: (
                            <div
                              style={{ display: "flex", paddingLeft: "10px" }}
                            >
                              {el.nome_articolo
                                ? el.nome_articolo
                                : el.data &&
                                  el.data.length > 0 &&
                                  el.data[0] &&
                                  el.data[0].item &&
                                  el.data[0].item.nome
                                ? el.data[0].item.nome
                                : ""}
                            </div>
                          ),
                          content: (
                            <div
                              style={{
                                display: "flex",
                                flexDirection: "column",
                                flex: 1,
                              }}
                            >
                              {el.data.map((cont, ind) => {
                                return (
                                  <div key={ind.toString()}>
                                    <VisitorInformation
                                      item={cont}
                                      updateVisitorInformation={
                                        updateVisitorInformation
                                      }
                                      productId={el.productId}
                                      index={ind}
                                      customStyle={customStyle}
                                      setCardError={(newBool, newCard) =>
                                        setCardErrorArrayCell(
                                          prodIndex,
                                          ind,
                                          newBool,
                                          newCard
                                        )
                                      }
                                    />
                                    <div
                                      style={
                                        ind !== el.data.length - 1
                                          ? {
                                              width: "100%",
                                              margin: "0 auto",
                                              height: 1,
                                              backgroundColor:
                                                "rgba(240,240,240,1)",
                                            }
                                          : null
                                      }
                                    />
                                  </div>
                                );
                              })}
                            </div>
                          ),
                        };
                      })}
                    />
                  ) : (
                    <div>{t("userInformation.info_empty")}</div>
                  )}
                  {anyCardRepetition && ( //if at least one card is provided for more than one user
                    <FormHelperText
                      className={classes.labelRootErrorCardRepetition}
                    >
                      {t("userInformation.error_card_repetitions")}
                    </FormHelperText>
                  )}
                </CardBody>
              </CardBody>
              {showError && (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    padding: "10px",
                  }}
                >
                  <h5 style={{ color: "#B33030", marginTop: 0 }}>
                    {t("userInformation.error_mandatory")}
                  </h5>
                </div>
              )}
              {/* ******* WEB >= 960 ********** */}
              <Hidden smDown implementation="css">
                <div className={classes.containerButtons}>
                  <GridContainer>
                    <GridItem
                      xs={8}
                      sm={6}
                      md={6}
                      lg={6}
                      style={{ textAlign: "right" }}
                    >
                      <Button
                        round
                        size="sm"
                        // color="github"
                        // className={classes.buttonBig}
                        // color="info"
                        onClick={() => {
                          var url = history.location.pathname;
                          url = url.slice(0, url.lastIndexOf("/"));
                          url =
                            url.slice(0, url.lastIndexOf("/")) +
                            "/shop/" +
                            home;

                          history.replace(url);
                        }}
                        style={{
                          backgroundColor: customStyle.buttonBackToMenu,
                        }}
                      >
                        <span className={classes.buttonTextNormal}>
                          {t("shippingAddress.back_menu")}
                        </span>
                      </Button>
                    </GridItem>
                    <GridItem xs={8} sm={6} md={6} lg={6}>
                      <Button
                        round
                        size="sm"
                        color="warning"
                        // className={classes.buttonBig}
                        // color="info"
                        disabled={
                          cartUnique?.length === 0 || cart?.length === 0
                        }
                        onClick={onClickContinue}
                        style={{
                          backgroundColor: customStyle.buttonContinue,
                        }}
                      >
                        <span className={classes.buttonTextNormal}>
                          {t("shippingAddress.continue")}
                        </span>
                      </Button>
                    </GridItem>
                  </GridContainer>
                </div>
              </Hidden>
            </Card>
          </div>
          {/* <div className="logo_emma">
            <img src={logo} alt="logo" />
          </div> */}
        </div>
      </MobileWrapper>
    </>
  );
}

BaseInformationList.propTypes = {
  currency: PropTypes.shape({
    name: PropTypes.string,
    rate: PropTypes.number,
    symbol: PropTypes.string,
  }).isRequired,
  articles: PropTypes.arrayOf(PropTypes.object).isRequired,
  shippingInfo: PropTypes.shape({
    type: PropTypes.string,
    email: PropTypes.string,
  }).isRequired,
  cartParams: PropTypes.shape({
    totalPrice: PropTypes.number,
    deliveryCost: PropTypes.number,
    servicesFees: PropTypes.number,
    total: PropTypes.number,
    cartCounter: PropTypes.number,
    totToShow: PropTypes.number,
    vat: PropTypes.number,
  }).isRequired,
  updateCart: PropTypes.func.isRequired,
  language: PropTypes.string.isRequired,
  cart: PropTypes.arrayOf(PropTypes.object),
  cartUnique: PropTypes.any,
  updateCartUnique: PropTypes.func.isRequired,
  history: PropTypes.any,
  museum: PropTypes.object,
  customStyle: PropTypes.object,
};

BaseInformationList.defaultProps = {
  museum: null,
  customStyle: {},
  cartUnique: {},
  cart: [],
  history: null,
};

export default withRouter(BaseInformationList);
